export const normalizeAllNode = (arr, normalizeFns) => {
  let normalizedArr = arr;

  for (const normalizeFn of normalizeFns) {
    normalizedArr = normalizeFn(normalizedArr);
  }

  return normalizedArr;
};
